/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'
import Item from '../ItemBox/item'
import ItemDetail from '../ItemDetail'
import ListItemContainer from './styled'
import Button from 'shared/Button'
import { handleAsyncRequest } from 'utils/helper'
import horseApi from 'apis/horseApi'
import Loading from 'shared/Loading'
import UseButton from '../ButtonAction/use'
import { NUMBER } from 'apps/constants'
import InfiniteScroll from 'react-infinite-scroll-component'
interface iprops {
  type: string
  onItemChooseSuccess: () => void
  itemSelect?: any
  isChangeItem?: boolean
  onButtonClick?: () => void
  setItemSelect: (item: any) => void
  horseId: number
}

const ListItem = ({ type, onItemChooseSuccess, itemSelect, isChangeItem = false, onButtonClick, setItemSelect, horseId }: iprops) => {
  const [showModal, setShowModal] = useState(false)
  const [items, setItems] = useState<any>()
  const [total, setTotal] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [params, setParams] = useState<any>({ type, change: isChangeItem, limit: NUMBER.FORTY, page: NUMBER.ONE })

  useEffect(() => {
    fetchSyncHorseItems()
  }, [type, params])

  const fetchSyncHorseItems = async () => {
    if(!items?.length) {
      setLoading(true)
    }
    const [, data]: any = await handleAsyncRequest(horseApi.getItemsWeapons(horseId, params))
    setLoading(false)

    if (data) {
      const records = data?.data.records
      setItems(params.page > NUMBER.ONE ? [...items, ...records] : records)
      setTotal(data?.data?.total)
    }
  }

  const handleViewMore = () => {
    setParams({ ...params, page: params.page + NUMBER.ONE })
  }

  const _onToggleModal = () => {
    setShowModal(!showModal)
    onButtonClick && onButtonClick();
  }

  const _onClickItem = (item: any) => {
    setItemSelect(item)
  }

  const _onSuccess = async () => {
    _onToggleModal()
    onItemChooseSuccess()
  }
  const _onSuccessCustom = async () => {
    onItemChooseSuccess()
  }

  return (
    <ListItemContainer>
      {loading ? (
        <Loading />
      ) : (
        <>
          {items?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={items.length}
                next={handleViewMore}
                hasMore={items.length < total}
                loader={''}
                height={550}
                className={`list-item ${total <= 40 ? 'h-auto' : ''}`}
              >
                {items?.map((d: any) => (
                  <Item
                    className={`${d.id === itemSelect?.id ? 'active' : ''} custom ${type}`}
                    key={d.id}
                    imgUrl={d.img}
                    onClickItem={() => _onClickItem(d)}
                    name={d.name}
                    rarityType={d.rarity_type}
                  />
                ))}
              </InfiniteScroll>
              <div className='row button-group d-flex align-items-center justify-content-center'>
                <Button type="btnView" buttonName='View' onClickButton={_onToggleModal} disabled={!itemSelect} width={150} />
                <UseButton itemToken={itemSelect?.item_token} horseId={horseId} onSuccess={_onSuccessCustom} isChangeItem={isChangeItem} isDisabled={!itemSelect}/>
              </div>
              <ItemDetail
                open={showModal}
                onCancel={_onToggleModal}
                itemToken={itemSelect?.item_token}
                onSuccess={_onSuccess}
                isChangeItem={isChangeItem}
                className={`${type}`}
                horseId={horseId}
              />
            </>
          ) : (
            <p className='not-found d-flex align-items-center justify-content-center'>No item</p>
          )}
        </>
      )}
    </ListItemContainer>
  )
}

export default ListItem
